/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { DraftMeta } from './DraftMeta';

export const DraftUpdate: core.serialization.ObjectSchema<serializers.DraftUpdate.Raw, Truvity.DraftUpdate> =
    core.serialization.object({
        meta: DraftMeta.optional(),
        values: core.serialization.lazy(() => serializers.CredentialClaimValues).optional(),
    });

export declare namespace DraftUpdate {
    export interface Raw {
        meta?: DraftMeta.Raw | null;
        values?: serializers.CredentialClaimValues.Raw | null;
    }
}
